import React from "react";
import {useParams,useSearchParams} from "react-router-dom";
import {QuoteWorkbench} from "@/components/quote_prep/workspace/QuoteWorkbench";

export default function QuoteWorkspace(){const {jobId}=useParams(),[params]=useSearchParams();return <QuoteWorkbench jobId={jobId} initialDraftId={params.get('draft')}/>;}